import AnimatedImage from 'core-lib/components/AnimatedImage';
import formatCurrency from 'core-lib/utils/currency';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { AddToCartType } from 'src/modules/parkplusStoreV2/types/cart';
import { PdpPropType } from 'src/modules/parkplusStoreV2/types/product';
import AddToCart from 'src/modules/parkplusStoreV2/uiComponents/AddToCart';
import MoreProductDetails from 'src/modules/parkplusStoreV2/uiComponents/PdpComponents/MoreProductDetails';
import StoreAppBar from 'src/modules/parkplusStoreV2/uiComponents/StoreAppBar';
import { Divider } from 'ui-v2/components/Divider';
import { Typography } from 'ui-v2/components/Typography';
import s from './InternalVoucherPdp.module.scss';

export const InternalVoucherPdp = ({ data }: PdpPropType) => {
  const showMrp = data?.loyaltyPrice < data?.price;
  return (
    <div className={s.root}>
      <StoreAppBar title="" showCart showShare renderAppBarOnly isSticky />
      <div className={s.header}>
        <div
          style={{
            backgroundImage: `url(${data?.descriptionImages[0]})`,
          }}
          className={s.voucherCard}
        >
          <div className={s.voucherAmount}>
            <Typography
              label={'Claim your'}
              variant="label_3_semi_bold"
              color="on_dark_bg"
              style={{ marginBottom: '2px' }}
            />

            <Typography
              label={data?.subtitle1}
              variant="h_1_bold"
              color="on_dark_bg"
            />
          </div>

          <div className={s.bottomText}>
            <div className={s.topTitle}>
              <div className={s.image}>
                <AnimatedImage src={data?.icon} alt="voucherimage" />
              </div>

              <Typography
                label={data?.title}
                variant="h_4_bold"
                color="on_dark_bg"
              />
            </div>

            {data?.expiry && (
              <div className={s.validity}>
                <Typography
                  label="Valid till"
                  variant="label_3_medium"
                  color="secondary"
                  style={{ marginBottom: '2px' }}
                />
                <Typography
                  label={data?.expiry}
                  variant="h_4_medium"
                  color="secondary"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={s.coreDetails}>
        <div className={s.priceContainer}>
          {data?.subtitle2 && (
            <Typography
              label={data?.subtitle2}
              variant="label_3_bold"
              color="offer"
            />
          )}
          <div className={s.wrapper}>
            <Typography
              label={formatCurrency(data?.loyaltyPrice)}
              variant="h_3_bold"
              color="offer"
            />
            {showMrp && (
              <Typography
                label={formatCurrency(data?.price)}
                variant="label_3_medium"
                color="secondary"
                style={{
                  textDecoration: 'line-through',
                }}
              />
            )}
          </div>
        </div>
        {data?.mlSavings > 0 && data?.mlUsed > 0 && (
          <div className={s.mlBenifit}>
            <div className={s.left}>
              <AnimatedImage
                src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240107140714746144.png"
                className={s.icon}
                alt="mlDrop"
              />
              <Typography
                label={`Claim ${formatCurrency(
                  data?.mlSavings
                )} OFF using ${formatFuelBalance(data?.mlUsed)}`}
                variant="label_3_semi_bold"
                color="positive"
              />
            </div>
            {/* <Typography label="Applied" variant="body_m" color="grey_60" /> */}
          </div>
        )}
      </div>
      <Divider variant="padded" />
      <MoreProductDetails data={data} />
      <AddToCart product={data} type={AddToCartType.ProductDescription} />
    </div>
  );
};
